// extracted by mini-css-extract-plugin
module.exports = {"team":"TeamList-module--team--1d0Oc","teamList":"TeamList-module--teamList--1v0-M","teamText":"TeamList-module--teamText--3F082"};